import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import store from './store';

// import { reducer } from './redux/reducer';
// import { createStore } from 'redux';

// Assets
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-image-crop/dist/ReactCrop.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

// const store = createStore(reducer);

ReactDOM.createRoot(document.getElementById('root')).render(
	<Provider store={store}>
		<App />
	</Provider>,
);
